import { render, staticRenderFns } from "./BalanceBanks.vue?vue&type=template&id=67b1b174&"
import script from "./BalanceBanks.vue?vue&type=script&lang=js&"
export * from "./BalanceBanks.vue?vue&type=script&lang=js&"
import style0 from "./BalanceBanks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BalanceBanks.vue"
export default component.exports